import { render } from "./PrizeBanner.vue?vue&type=template&id=e1caa45c&scoped=true"
import script from "./PrizeBanner.vue?vue&type=script&lang=js"
export * from "./PrizeBanner.vue?vue&type=script&lang=js"

import "./PrizeBanner.vue?vue&type=style&index=0&id=e1caa45c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1caa45c"]])

export default __exports__